module.exports = __webpack_public_path__ + "img/poer1_bg.8b2d3f2c.jpg";